import React from 'react';
import setIconStatus from './setIconStatus';

export const listVersion = ['V-Init', 'V0', 'V1', 'VX'];

export const listTypeOfReport = [
  'project_state',
  'evolution_project',
  'federation',
  'planning',
  'gap',
  'meeting_report'
];

export const versionToIndex = {
  'V-init': 0,
  V0: 1,
  V1: 2,
  VX: 3
};
export const listItems = [
  'what',
  'why',
  'prior',
  'actors',
  'context',
  'cost',
  'risks',
  'planing',
  'utility',
  'plan_com'
];
export const listObjectForItems = {
  what: null,
  why: null,
  prior: 'studies',
  actors: 'actors_list',
  context: 'factors',
  cost: 'costs',
  risks: 'risk_list',
  planing: 'deliverables',
  utility: 'deliverables',
  plan_com: 'deliverables_plan_com'
};
export const typeOfComparaison = {
  V0toV1: (
    <div>
      <span>{setIconStatus(null, 'V0', false, 19)}</span>
      <span style={{ margin: '0px 10px 0px 5px' }}>vs</span>
      <span>{setIconStatus(null, 'V1', false, 19)}</span>
    </div>
  ),
  V0toVX: (
    <div>
      <span>{setIconStatus(null, 'V0', false, 19)}</span>
      <span style={{ margin: '0px 10px 0px 5px' }}>vs</span>
      <span>{setIconStatus(null, 'VX', false, 19)}</span>
    </div>
  )
};
export const listIDForGetIndicators = {
  project_state: [
    'project_stateindicators',
    'project_staterisk',
    'project_stategantt_planning',
    'project_stategantt_federation'
  ],
  evolution_project: [
    'evolution_projecttime',
    'evolution_projectcost',
    'evolution_projectutility',
    'evolution_projectfederation'
  ],
  federation: ['federationgantt_federation'],
  planning: ['planninggantt_planning'],
  gap: ['gapgantt_gap'],
  meeting_report: []
};

export const getIndexByVersionSelected = (status, data) => {
  switch (status) {
    case 'V-Init':
      return 0;
    case 'V0':
      return 1;
    case 'V1':
      return 2;
    case 'VX':
      return data.length - 1;
    default:
      return 1;
  }
};
